function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as s } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const c = (_param)=>{
    var { color: l , size: e = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = h(), i = l !== null && l !== void 0 ? l : a ? t.colors.inverse : t.colors.neutralHigh, { skinName: n  } = s();
    return n.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: i,
            d: "M2 12C2 6.484 6.484 2 12 2s10 4.484 10 10-4.484 10-10 10S2 17.516 2 12zm16.604.005a.534.534 0 00-.537-.538l-5.521-.011V5.924a.534.534 0 00-.538-.538.534.534 0 00-.537.538v5.532H5.938a.534.534 0 00-.537.537.534.534 0 00.537.538l5.521.011v5.532a.534.534 0 00.914.377.535.535 0 00.161-.377v-5.532h5.533c.147 0 .28-.065.376-.161a.535.535 0 00.161-.376z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: i,
            d: "M11.617 1c.287 0 .588.006.845.013 2.154.05 10.541.901 10.538 11.018 0 10.136-8.397 10.925-10.498 10.963-.194.003-.419.006-.648.006-.118 0-.24 0-.356-.003C9.288 22.966 1 22.167 1 11.966 1 1.776 9.209 1.019 11.42 1h.197zm1.067 11.654h4.8a.69.69 0 00.688-.685.689.689 0 00-.688-.689h-4.8V6.534a.689.689 0 00-1.378 0v4.743h-4.79a.689.689 0 100 1.377h4.79v4.812a.689.689 0 001.378 0v-4.812z"
        })
    }));
}, p = c;
export { p as default };
